const base64UrlToBase64 = (value) => {
  const base64 = String(value).replace(/-/g, "+").replace(/_/g, "/");
  const padLength = (4 - (base64.length % 4)) % 4;
  return base64 + "=".repeat(padLength);
};

export const decodeJwtPayload = (token) => {
  if (!token || typeof token !== "string") {
    return null;
  }

  const parts = token.split(".");
  if (parts.length < 2 || !parts[1]) {
    return null;
  }

  try {
    const json = atob(base64UrlToBase64(parts[1]));
    const payload = JSON.parse(json);
    return payload && typeof payload === "object" ? payload : null;
  } catch {
    return null;
  }
};

export const getJwtExpiryMs = (token) => {
  const payload = decodeJwtPayload(token);
  if (payload == null || typeof payload.exp !== "number") {
    return null;
  }
  return payload.exp * 1000;
};

export const isJwtExpired = (token, now = Date.now()) => {
  const expiryMs = getJwtExpiryMs(token);
  if (expiryMs == null) {
    return false;
  }
  return now >= expiryMs;
};
